import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const HERITAGE_IMAGE =
  "https://i.ibb.co/fdQC83jh/Foto-Juan-y-Mari-a.jpg";

const HERITAGE_DETAIL =
  "https://customer-assets.emergentagent.com/job_aceite-granada/artifacts/9mmw07r7_carrusel%202.jpg";

export default function Heritage() {
  const { t } = useLang();
  const paragraphs = t("heritage.paragraphs");
  const stats = t("heritage.stats");

  return (
    <section
      id="historia"
      data-testid="heritage-section"
      className="relative bg-cream-100 py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <span className="text-[11px] uppercase tracking-[0.32em] text-gold-deep font-medium">
            {t("heritage.overline")}
          </span>
          <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] text-olive-900 font-medium">
            {t("heritage.h2_a")} <br />
            {t("heritage.h2_b")} <span className="italic">{t("heritage.h2_c")}</span>.
          </h2>
          <div className="mt-8 space-y-5 text-olive-800/85 font-light text-base sm:text-lg leading-relaxed">
            {paragraphs.map((p) => (
              <p key={p.slice(0, 40)}>{p}</p>
            ))}
          </div>
          <div className="mt-10 flex flex-wrap gap-x-10 gap-y-6">
            {stats.map((s) => (
              <div key={s.k} className="border-l border-gold pl-4">
                <div className="font-serif text-3xl text-olive-900">{s.k}</div>
                <div className="text-[11px] uppercase tracking-[0.24em] text-olive-800/70 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 relative">
          <div className="aspect-[3/2] overflow-hidden bg-cream-200">
            <img
              src={HERITAGE_IMAGE}
              alt={t("heritage.image_alt")}
              className="h-full w-full object-cover object-top scale-[1.05]"
              loading="lazy"
            />
          </div>
          <figcaption className="mt-4 text-[11px] uppercase tracking-[0.24em] text-olive-800/60">
            {t("heritage.caption")}
          </figcaption>

          <div className="hidden md:block absolute -bottom-10 -left-10 bg-cream-200 border border-cream-400 p-8 max-w-xs">
            <p className="font-serif italic text-olive-900 text-xl leading-snug">
              {t("heritage.quote")}
            </p>
            <div className="mt-4 text-[11px] uppercase tracking-[0.24em] text-olive-800/70">
              {t("heritage.quote_author")}
            </div>
          </div>

          <div className="mt-16 lg:mt-24 grid grid-cols-5 gap-6 items-end">
            <div className="col-span-3 sm:col-span-2 aspect-square overflow-hidden bg-cream-200">
              <img
                src={HERITAGE_DETAIL}
                alt={t("heritage.detail_alt")}
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="col-span-2 sm:col-span-3 pl-2">
              <span className="text-[10px] uppercase tracking-[0.32em] text-gold-deep font-medium">
                {t("heritage.detail_overline")}
              </span>
              <p className="mt-3 font-serif italic text-olive-900 text-lg sm:text-xl leading-snug">
                {t("heritage.detail_caption")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
